import React from 'react';
import ImageComponent from 'atoms/Image';
import { AnchorWithLink } from 'atoms/Anchor';
/**
 *  App Button Item Component
 * @param {*} props - Object
 */

const FooterAppButtonsComp = props => {
  const { buttonContent = [] } = props;

  const getItems = list => {
    return list.map((item, ind) => {
      return (
        <AnchorWithLink href={item.linkTo} targetWindow='_blank' type='external'>
          <ImageComponent key={ind} srcFile={item.url} alt={`${item.name}`} />
        </AnchorWithLink>
      );
    });
  };
  return <React.Fragment>{getItems(buttonContent)}</React.Fragment>;
};

export { FooterAppButtonsComp };
